export function getPaymentStatus(payments, paymentCode) {
    for (let i = 0; i < payments.length; i++) {
        if (payments[i].paymentCode === paymentCode) {
            return payments[i].status
        }
    }
    return null // payment with given paymentCode not found
}
